import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  const isLarge = size === 'large';

  return (
    <Link
      to={`/comic/${comic.slug}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className={`relative overflow-hidden ${isLarge ? 'aspect-[3/4]' : 'aspect-[3/4]'}`}>
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - 皮皮喵漫画在线免费阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-md text-xs font-medium whitespace-nowrap ${
            comic.status === 'ongoing'
              ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
              : 'bg-secondary-500 text-background-50 dark:text-foreground-950'
          }`}>
            {comic.status === 'ongoing' ? '连载中' : '已完结'}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-foreground-900/70 text-background-50 whitespace-nowrap">
            {comic.rating}分
          </span>
        </div>
      </div>
      <div className="p-3 md:p-5">
        <h3 className="text-sm md:text-base font-semibold text-foreground-900 font-heading group-hover:text-primary-500 transition-colors line-clamp-1">
          {comic.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
          {comic.author}
        </p>
        <div className="mt-2 flex flex-wrap items-center gap-2">
          {comic.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-md text-xs bg-secondary-100 text-secondary-700 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
        {isLarge && (
          <p className="mt-2 text-xs text-foreground-600 line-clamp-2 leading-relaxed">
            {comic.description}
          </p>
        )}
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
          <span>更新至{comic.chapters}话</span>
          <span>{Math.floor(comic.views / 10000)}万阅读</span>
        </div>
      </div>
    </Link>
  );
}